import { useDispatch, useSelector } from 'react-redux';
import { getNotificationsLastMessageByType } from '../../Notifications/notificationsSelectors';
import { IRootState } from '../../../app/types/rootReducers.t';
import { NOTIFICATIONS_MESSAGE_TYPES } from '../../Notifications/notificationsConstants';
import { useLocation } from 'react-router';
import appHistory from '../../../app/appHistory';
import { PUBLIC_URL } from '../../../config';
import { Button } from 'react-bootstrap';
import { ACHIEVEMENTS_CONGRATULATIONS } from './AchievementCongratulationsConstants';
import React, { useCallback, useMemo } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import LangWithComponents from '../../../providers/LangProvider/components/LangWithComponents';
import useMobileAccountBoxButtonsHandlers
    from '../../../mobileAppCore/components/MobileAccountBox/useMobileAccountBoxButtonsHandlers';
import { getIsLocationPlatformDesktopSelector } from '../../Location/locationSelectors';
import classNames from 'classnames';
import { AchievementCongratulationsPageStyled } from './styled/AchievementCongratulationsPageStyled';
import { locationSlice } from '../../Location/locationReducer';

export default function AchievementCongratulationsPage() {
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();
    const { search } = useLocation();
    const lastMessage = useSelector((state: IRootState) =>
        getNotificationsLastMessageByType(state, NOTIFICATIONS_MESSAGE_TYPES.ACHIEVEMENT) as any);
    const isDesktop = useSelector(getIsLocationPlatformDesktopSelector);
    const {
        handleStartRealButtonClick,
    } = useMobileAccountBoxButtonsHandlers();

    const params = useMemo(() => {
        if (!lastMessage) return null;
        return lastMessage.payload;
    }, [lastMessage]);

    const config = useMemo(() => {
        if (!params) return null;
        return ACHIEVEMENTS_CONGRATULATIONS[params?.achievement_name];
    }, [params]);

    const onButtonClick = useCallback((e) => {
        const type = e.currentTarget.name;
        if (config?.[type].slide) {
            appHistory.goBack();
            setTimeout(() => {
                dispatch(locationSlice.actions.openLocationAction({ name: config[type].slide }));
            }, 100);
        } else if (config?.[type]?.handler) {
            switch (config[type].handler) {
                case 'handleStartRealButtonClick':
                    handleStartRealButtonClick(e);
                    break;
            }
            appHistory.goBack();
        } else if (config?.[type]?.link) {
            appHistory.push(config[type].link);
        } else {
            appHistory.goBack();
        }
    }, [config, dispatch, handleStartRealButtonClick]);

    if (!lastMessage) {
        const params = new URLSearchParams(search);
        if (params.getAll('s').includes('achievement')) {
            appHistory.goBack();
        }
        return null;
    }

    if (!config) {
        appHistory.goBack();
        return null;
    }

    return <div className={classNames('d-flex text-center align-items-center', {
        'flex-column': !isDesktop,
        'justify-content-center': isDesktop,
        'gap-5': isDesktop,
    })}>
        <img src={`${PUBLIC_URL}/assets/achievements/${config.image_name || params.achievement_name}.png`}
             width={isDesktop ? 220 : 120}
             height={isDesktop ? 220 : 120}
             alt={params.achievement_name}/>

        <AchievementCongratulationsPageStyled isDesktop={isDesktop}>
            <h2 dangerouslySetInnerHTML={{ __html: getLangPath(`achievements.congratulations.${params.achievement_name}.title`) }}/>

            <span className={'f16 fw400 mt-2'}
                  dangerouslySetInnerHTML={{ __html: getLangPath(`achievements.congratulations.${params.achievement_name}.description`) }}/>

            {
                config.button_primary && <Button variant={'primary'}
                                                 name={'button_primary'}
                                                 onClick={onButtonClick}
                                                 className={'mt-4 w-100'}>
                    <LangWithComponents langPath={config.button_primary.label}/>
                </Button>
            }
            {
                config.button_secondary && <Button variant={'tertiary'}
                                                   name={'button_secondary'}
                                                   onClick={onButtonClick}
                                                   className={'mt-2 w-100'}>
                <span style={{ fontSize: '14px', fill: 'white' }}><LangWithComponents
                    langPath={config.button_secondary.label}
                /></span>
                </Button>
            }
        </AchievementCongratulationsPageStyled>
    </div>;
}
